export const languageList = [
  {
    id: 1,
    name: 'Afrikaans',
  },
  {
    id: 2,
    name: 'Albanian',
  },
  {
    id: 3,
    name: 'Arabic',
  },
  {
    id: 4,
    name: 'Armenian',
  },
  {
    id: 5,
    name: 'Basque',
  },
  {
    id: 6,
    name: 'Bengali',
  },
  {
    id: 7,
    name: 'Bulgarian',
  },
  {
    id: 8,
    name: 'Burmese ',
  },
  {
    id: 9,
    name: 'Cambodian',
  },
  {
    id: 10,
    name: 'Catalan',
  },
  {
    id: 11,
    name: 'Chinese (Simplified)',
  },
  {
    id: 12,
    name: 'Chinese (Traditional)',
  },
  {
    id: 13,
    name: 'Croatian',
  },
  {
    id: 14,
    name: 'Czech',
  },
  {
    id: 15,
    name: 'Danish',
  },
  {
    id: 16,
    name: 'Dutch',
  },
  {
    id: 17,
    name: 'Dzongkha',
  },
  {
    id: 18,
    name: 'English (US)',
  },
  {
    id: 19,
    name: 'English (UK)',
  },
  {
    id: 20,
    name: 'Estonian',
  },
  {
    id: 21,
    name: 'Fiji',
  },
  {
    id: 22,
    name: 'Finnish',
  },
  {
    id: 23,
    name: 'French',
  },
  {
    id: 24,
    name: 'Georgian',
  },
  {
    id: 25,
    name: 'German',
  },
  {
    id: 26,
    name: 'Greek',
  },
  {
    id: 27,
    name: 'Gujarati',
  },
  {
    id: 28,
    name: 'Hebrew',
  },
  {
    id: 29,
    name: 'Hindi',
  },
  {
    id: 30,
    name: 'Hungarian',
  },
  {
    id: 31,
    name: 'Icelandic',
  },
  {
    id: 32,
    name: 'Indonesian',
  },
  {
    id: 33,
    name: 'Irish',
  },
  {
    id: 34,
    name: 'Italian',
  },
  {
    id: 35,
    name: 'Japanese',
  },
  {
    id: 36,
    name: 'Javanese',
  },
  {
    id: 37,
    name: 'Khmer ',
  },
  {
    id: 38,
    name: 'Korean',
  },
  {
    id: 39,
    name: 'Lao ',
  },
  {
    id: 40,
    name: 'Latin',
  },
  {
    id: 41,
    name: 'Latvian',
  },
  {
    id: 42,
    name: 'Lithuanian',
  },
  {
    id: 43,
    name: 'Macedonian',
  },
  {
    id: 44,
    name: 'Malay',
  },
  {
    id: 45,
    name: 'Malayalam',
  },
  {
    id: 46,
    name: 'Maltese',
  },
  {
    id: 47,
    name: 'Maori',
  },
  {
    id: 48,
    name: 'Marathi',
  },
  {
    id: 49,
    name: 'Mongolian',
  },
  {
    id: 50,
    name: 'Nepali',
  },
  {
    id: 51,
    name: 'Norwegian',
  },
  {
    id: 52,
    name: 'Persian',
  },
  {
    id: 53,
    name: 'Polish',
  },
  {
    id: 54,
    name: 'Portuguese',
  },
  {
    id: 55,
    name: 'Punjabi',
  },
  {
    id: 56,
    name: 'Quechua',
  },
  {
    id: 57,
    name: 'Romanian',
  },
  {
    id: 58,
    name: 'Russian',
  },
  {
    id: 59,
    name: 'Samoan',
  },
  {
    id: 60,
    name: 'Serbian',
  },
  {
    id: 61,
    name: 'Slovak',
  },
  {
    id: 62,
    name: 'Slovenian',
  },
  {
    id: 63,
    name: 'Spanish',
  },
  {
    id: 64,
    name: 'Swahili',
  },
  {
    id: 65,
    name: 'Swedish',
  },
  {
    id: 66,
    name: 'Tagalog ',
  },
  {
    id: 67,
    name: 'Tamil',
  },
  {
    id: 68,
    name: 'Tatar',
  },
  {
    id: 69,
    name: 'Telugu',
  },
  {
    id: 70,
    name: 'Thai',
  },
  {
    id: 71,
    name: 'Tibetan',
  },
  {
    id: 72,
    name: 'Tonga',
  },
  {
    id: 73,
    name: 'Turkish',
  },
  {
    id: 74,
    name: 'Ukrainian',
  },
  {
    id: 75,
    name: 'Urdu',
  },
  {
    id: 76,
    name: 'Uzbek',
  },
  {
    id: 77,
    name: 'Vietnamese',
  },
  {
    id: 78,
    name: 'Welsh',
  },
  {
    id: 79,
    name: 'Xhosa',
  },
];
